"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayPeriodDailyBreakdownView = exports.PAY_PERIOD_DAILY_BREAKDOWN_VIEW_COLUMN_TEST_ID = exports.PAY_PERIOD_DAILY_BREAKDOWN_VIEW_TEST_ID = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const luxon_1 = require("luxon");
const Table_1 = require("@amzn/atoz-web/Table");
const Card_1 = require("@amzn/atoz-web/Card");
const Col_1 = require("@amzn/atoz-web/Col");
const Row_1 = require("@amzn/atoz-web/Row");
const Text_1 = require("@amzn/atoz-web/Text");
const Hr_1 = require("@amzn/atoz-web/Hr");
const Button_1 = require("@amzn/atoz-web/Button");
const Icons_1 = require("@amzn/atoz-web/Icons");
const Theme_1 = require("@amzn/atoz-web/Theme");
const SpinnerOverlay_1 = require("../../components/SpinnerOverlay");
const DateManagement_1 = require("../../utils/DateManagement");
const usePayPeriodDailyBreakdownView_1 = require("../../components/PayPeriodDailyBreakdownView/hooks/usePayPeriodDailyBreakdownView");
const consts_1 = require("../../consts");
const BIAnalytics_1 = require("../../utils/BIAnalytics/BIAnalytics");
exports.PAY_PERIOD_DAILY_BREAKDOWN_VIEW_TEST_ID = 'pay-period-daily-breakdown-view';
exports.PAY_PERIOD_DAILY_BREAKDOWN_VIEW_COLUMN_TEST_ID = 'pay-period-daily-breakdown-view-column';
const PayPeriodDailyBreakdownView = ({ payPeriodDailyBreakdown, searchParamsDate, onRedirect, closeFlyout, isLoading, isPunchSectionWebEnabled = false, renderPunchFeature, renderHourlyBreakdownFeature, navigateToToday }) => {
    if (isPunchSectionWebEnabled && location.search !== '')
        history.replaceState({}, '', consts_1.ATOZ_FEATURE_PATH.TIME_CARD);
    const { t } = (0, react_i18next_1.useTranslation)();
    const dateCell = ({ data }) => (react_1.default.createElement(Col_1.Col, { width: 48 },
        react_1.default.createElement(Row_1.Row, { alignItems: "center" },
            react_1.default.createElement(Text_1.Text, null,
                react_1.default.createElement("strong", null, (0, DateManagement_1.getDisplayWeekday)(data.date))),
            data.anomalyFound && (react_1.default.createElement(Icons_1.IconAlertCircleFill, { color: "red70", size: Icons_1.IconSize.ExtraSmall, margin: 4, title: t('time_and_attendance_Timecard_Requires_Atention') }))),
        react_1.default.createElement(Text_1.Text, { fontSize: "T100" }, (0, DateManagement_1.getDisplayMonthDay)(data.date))));
    const { data, columns } = (0, usePayPeriodDailyBreakdownView_1.usePayPeriodDailyBreakdownView)({
        payPeriodDailyBreakdown,
        dateCell
    });
    const renderPunchDetails = (data, index) => (react_1.default.createElement(Col_1.Col, { dataTestId: `punch-details-${index}` },
        react_1.default.createElement(Hr_1.Hr, null),
        renderPunchFeature(data.date),
        react_1.default.createElement(Hr_1.Hr, null),
        renderHourlyBreakdownFeature(data.date)));
    const getRowAttributesExpandable = ({ data, index }) => ({
        dataTestId: `${exports.PAY_PERIOD_DAILY_BREAKDOWN_VIEW_COLUMN_TEST_ID}-expandable-${index}`,
        expandableContent: ({ data, index }) => [renderPunchDetails(data, index)],
        expandableTriggerText: t('time_and_attendance_Timecard_PayPeriodDailyBreakDown_RowExpansionAccessibilityText_See'),
        shouldVisuallyHideTriggerText: true
    });
    const getRowAttributesRedirect = ({ data, index }) => ({
        dataTestId: exports.PAY_PERIOD_DAILY_BREAKDOWN_VIEW_COLUMN_TEST_ID + `-${index}`,
        onClick: () => {
            if (onRedirect) {
                onRedirect(data.date);
            }
            if (closeFlyout) {
                closeFlyout();
            }
        }
    });
    const autoExpandRow = (toExpandIndex) => {
        var _a;
        if (toExpandIndex < 0) {
            return;
        }
        const button = document.querySelector(`[data-test-id="${exports.PAY_PERIOD_DAILY_BREAKDOWN_VIEW_COLUMN_TEST_ID}-expandable-${toExpandIndex}"] button`);
        if (!document.querySelector(`[data-test-id="punch-details-${toExpandIndex}"]`)) {
            button === null || button === void 0 ? void 0 : button.click();
        }
        (_a = button === null || button === void 0 ? void 0 : button.scrollIntoView) === null || _a === void 0 ? void 0 : _a.call(button, { behavior: 'smooth' });
    };
    const onSeeTodayClick = () => {
        var _a;
        const todaysDateInISO = luxon_1.DateTime.local().toISODate();
        const autoExpandIndex = Object.keys(payPeriodDailyBreakdown).indexOf(todaysDateInISO);
        if (autoExpandIndex < 0) {
            navigateToToday();
        }
        else {
            autoExpandRow(autoExpandIndex);
        }
        (_a = BIAnalytics_1.BIAnalytics.clickSeeTodayButton) === null || _a === void 0 ? void 0 : _a.call(BIAnalytics_1.BIAnalytics);
    };
    (0, react_1.useEffect)(() => {
        if (!isLoading && isPunchSectionWebEnabled) {
            let autoExpandIndex;
            if (searchParamsDate) {
                autoExpandIndex = Object.keys(payPeriodDailyBreakdown).indexOf(searchParamsDate);
            }
            else {
                const todaysDateInISO = luxon_1.DateTime.local().toISODate();
                autoExpandIndex = Object.keys(payPeriodDailyBreakdown).indexOf(todaysDateInISO);
            }
            autoExpandRow(autoExpandIndex);
        }
    }, [isLoading, isPunchSectionWebEnabled]);
    return (react_1.default.createElement(StyledCard, { flex: 1 },
        react_1.default.createElement(SpinnerOverlay_1.SpinnerOverlay, { isLoading: isLoading },
            react_1.default.createElement(Col_1.Col, { dataTestId: exports.PAY_PERIOD_DAILY_BREAKDOWN_VIEW_TEST_ID, width: '100%', gridGap: "S200", id: exports.PAY_PERIOD_DAILY_BREAKDOWN_VIEW_TEST_ID },
                react_1.default.createElement(Row_1.Row, { alignItems: "center", justifyContent: "space-between" },
                    react_1.default.createElement(Text_1.H2, { fontSize: "T200" },
                        react_1.default.createElement("strong", null, t('time_and_attendance_Timecard_PayPeriodDailyBreakDown_DailyBreakdown'))),
                    isPunchSectionWebEnabled && (react_1.default.createElement(Button_1.Button, { variant: Button_1.ButtonVariant.Tertiary, onClick: onSeeTodayClick }, t('time_and_attendance_Timecard_PayPeriodDailyBreakDown_SeeToday')))),
                react_1.default.createElement(Table_1.Table, { "aria-label": t('time_and_attendance_Timecard_PayPeriodDailyBreakDown_DailyBreakdown'), columns: columns, getRowAttributes: isPunchSectionWebEnabled
                        ? getRowAttributesExpandable
                        : getRowAttributesRedirect, data: data, actionHeader: t('time_and_attendance_Timecard_PayPeriodBreakDown_Details'), shouldAutoCollapseOnExpand: true })))));
};
exports.PayPeriodDailyBreakdownView = PayPeriodDailyBreakdownView;
const StyledCard = (0, Theme_1.styledWithTheme)(Card_1.Card)(`
	     border: none;
       width: 100%;
	 `);
